import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .use({
    type: "logger",

    log(args) {
      this.output("log", args);
    },

    warn(args) {
      this.output("warn", args);
    },

    error(args) {
      this.output("error", args);
    },

    output() {},
  })
  .init({
    debug: true,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    whitelist: ["en", "es"],
    supportedLngs: ["en", "es"],
    load: "languageOnly",
    nsSeparator: ":::",
    keySeparator: "::",
  });
